import Footer from '../../components/Footer/Footer'
import ModalForm from '../../components/Form/ModalForm'
import "./Client.css"

export default function Client() {
  return (
    <>
      <main className="client">
        <div className="client__content">
          <h2>Наши клиенты</h2>
          <p> Мы только открылись и очень ждем клиентов </p>
          <p>
            Мы приглашаем к <span>сотрудничеству</span> всех, кто хочет вместе с нами развивать
            свой бизнес, используя <span>понятные</span>, <span>отечественные</span>, сделанные хоть и нашими
            руками, но под чутким руководством Заказчика <span>инструменты</span>. Это будет
            <span> взаимовыгодное</span> и <span>долгосрочное сотрудничество</span>.
          </p>
          <p>
            Напишите нам! Давайте расти вместе!
          </p>
          <ModalForm />

        </div>

        <Footer />
      </main>
    </>
  )
}
